//? MBirdSdk is imported from another file through script tag in index.html
//? you can find this file in public/assets/js/mbird-sdk and no you can not import it directly from file then it will give error
/* global MBirdSdk */

const isKiosk = ()=>{
    // const kiosk = sessionStorage.getItem("kiosk");

    // console.log(kiosk, "kiosk");
    // return kiosk === "true";

    if (!MBirdSdk) return false;

    const connectedToKiosk = MBirdSdk.isConnected();

    if (!connectedToKiosk) return false;

    return true;

}

export default isKiosk;